<div class="modal-header">
    <h4 class="modal-title pull-left">{{help.title}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div [innerHTML]="help.content | safeHTML"></div>
</div>
